import { render, staticRenderFns } from "./AdvancedBox.vue?vue&type=template&id=5d322d7e&"
import script from "./AdvancedBox.vue?vue&type=script&lang=js&"
export * from "./AdvancedBox.vue?vue&type=script&lang=js&"
import style0 from "./AdvancedBox.vue?vue&type=style&index=0&id=5d322d7e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports